export enum SubscriptionType {
    UNKNOWN,
    PAYG,
    GROW,
    TEAM,
    PRO
}